import type { QueryResult } from 'utils/api'

import { useApiQuery } from '../useApiQuery'

export type CapturedCommChannel = 'email' | 'sms'
export type CapturedCommProviderStatus = 'validated' | 'rejected'

export interface CapturedComm {
  id: string
  channel: CapturedCommChannel
  toAddress: string
  fromAddress: string | null
  subject: string | null
  body: string
  metadata: Record<string, unknown>
  providerStatus: CapturedCommProviderStatus
  providerError: string | null
  providerRef: string | null
  scheduledCommunicationId: string | null
  contactId: string | null
  capturedAt: string
}

export interface CapturedCommsParams {
  channel?: CapturedCommChannel
  toAddress?: string
  scheduledCommunicationId?: string
  skip?: number
  take?: number
}

interface CapturedCommsResponse {
  rows: CapturedComm[]
  total: number
}

export function useCapturedComms(params: CapturedCommsParams = {}): QueryResult<CapturedCommsResponse> {
  const query = new URLSearchParams()
  if (params.channel) {
    query.set('channel', params.channel)
  }
  if (params.toAddress) {
    query.set('toAddress', params.toAddress)
  }
  if (params.scheduledCommunicationId) {
    query.set('scheduledCommunicationId', params.scheduledCommunicationId)
  }
  if (params.skip !== undefined) {
    query.set('skip', String(params.skip))
  }
  if (params.take !== undefined) {
    query.set('take', String(params.take))
  }
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return useApiQuery<CapturedCommsResponse>(`/api/captured-comms${suffix}`)
}

export function useCapturedComm(id: string | null): QueryResult<CapturedComm> {
  return useApiQuery<CapturedComm>(id ? `/api/captured-comms/${id}` : null)
}
